import { DefinedPropertyObject } from "../../../api/GenericTypes";

import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import { CustomImportLog, CustomImportLogFilters } from "../../../api/CustomImports";
import {
  TabStoreFilterFormProvider,
  TabStoreFilterSidebarProps,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { defaultCustomImportLogsFilters } from "./CustomImportLogsTable";
export interface CustomImportLogFilterForm {}

const defaultValues: DefinedPropertyObject<CustomImportLogFilterForm> = {};

export const customImportsFormToFilters = (form: CustomImportLogFilterForm): CustomImportLogFilters => {
  let filters: CustomImportLogFilters = {};

  return filters;
};

export const filtersToInstrumentsForm = (filters: CustomImportLogFilters): CustomImportLogFilterForm => {
  return {};
};

export const CustomImportLogFilterBar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
}: TabStoreFilterSidebarProps<CustomImportLog, CustomImportLogFilterForm, CustomImportLogFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultCustomImportLogsFilters}
      formToFilters={customImportsFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, errors, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <></>
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
